export const COLOR_BACKGROUND_BODY = "#F9F9F9";
export const COLOR_GRADIENT_1 = '#B446FF';
export const COLOR_GRADIENT_2 = '#6F68FE';
export const COLOR_SPECIAL = '#6F67FE';
export const COLOR_GREY = '#999999';
export const COLOR_GREY_LIGHT = '#C6C6C6';

export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLACK = "#000000";
export const COLOR_HEADER_MENU_LINK_HOVER = '#BE5220';